export default "__VITE_ASSET__77f014e4__"